<app-map-navigation-item>
  <span class="map-navigation-item-divider"></span>
  <span
    class="rb-ic fs-2xl hover-effect p-2 navigation-item-btn"
    [class.rb-ic-delete]="!isLoading"
    [class.rb-ic-delete-disabled-bold]="isLoading"
    [class.disabled]="isLoading"
    (click)="openDeleteAllVisibleSimulationsDialog(removeUserDialog, 'middle')"
    placement="start"
    ngbTooltip="Delete all visible warnings"
    tooltipClass="custom-tooltip"
    [openDelay]="1000"
  >
  </span>
</app-map-navigation-item>

<ng-template #removeUserDialog>
  <rb-dialog
    dialogTitle="Delete all visible simulations"
    headline="Delete all visible simulations"
    confirmationButtonLabel="Confirm"
    cancelButtonLabel="Cancel"
    [alert]="{ type: 'error', errorCode: '' }"
    data-cy="delete-user-dialog"
    style="color: black"
  >
    <p style="color: black; margin: 0 0 0.75rem">
      Are you sure you want to delete <b>{{ this.visibleSimulationsCount }}</b> visible simulations?
    </p>
    <p style="color: black; margin: 0 0 0.75rem">
      This action cannot be undone and will delete all
      <b>{{ this.visibleSimulationsCount }}</b> visible simulations.
    </p>
    <p style="color: black; margin: 0">Please confirm if you wish to proceed.</p>
  </rb-dialog>
</ng-template>
